import React from 'react';

export default function EpicOption({ e, existingEpics, selected, toggle }) {
  const alreadyLinked = existingEpics.has(e.key);
  const isSelected = selected.has(e.key);
  return (
    <div
      onClick={() => !alreadyLinked && toggle(e.key)}
      className={`flex items-center gap-[10px] py-[10px] px-[14px] [border-bottom:0.5px_solid_#f0eeeb] ${alreadyLinked ? 'cursor-default' : 'cursor-pointer'}`}
      style={{
        background: alreadyLinked ? '#f9f9f9' : isSelected ? '#f0effe' : '#fff',
      }}
    >
      <input
        type="checkbox"
        checked={alreadyLinked || isSelected}
        disabled={alreadyLinked}
        onChange={(ev) => {
          ev.stopPropagation();
          !alreadyLinked && toggle(e.key);
        }}
        onClick={(ev) => ev.stopPropagation()}
        className="[accent-color:#68C4D4]"
      />
      <div className="[flex:1]">
        <div
          className={`text-[12px] font-medium ${alreadyLinked ? 'text-grey-light' : 'text-ink'}`}
        >
          {e.summary}
        </div>
        <div className="text-[10px] text-grey-light">
          {e.key}
          {alreadyLinked ? ' — déjà importé' : ''}
          {e.joursVendus != null ? ` · ${e.joursVendus}j vendus` : ''}
        </div>
      </div>
    </div>
  );
}
